import { createObject, createSprite, CreateObjectArgs } from "../core";
import { fontDict } from "../fontDict";
import { InputEvents, Metrics, ObjectState, Obj, Surface } from "../types";

export type CreateParagraphObjectArgs = Omit<CreateObjectArgs, "sprite"> & {
  text: string;
  w: number;
  h: number;
}

export const createParagraphObject = (args: CreateParagraphObjectArgs) => {
  const { w, h } = args;
  let text = args.text;
  const sprite = createSprite({ w, h, fill: 0 });
  const obj = createObject({ ...args, sprite });

  const step = (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => {
    if (args.step) {
      args.step(startTime, timestamp, inputEvents, metrics, inFocus, objectState, surface, obj);``
    }

    // clear sprite
    obj.sprite = createSprite({ w: obj.w, h: obj.h, fill: 0 });

    // lay out sprites in a simple word-wrap style
    let cx = 0;
    let cy = 0;
    let maxRowH = 0;

    text.split("").forEach((char: string) => {
      const { w, h, c } = fontDict[char] || fontDict[" "];

      // if this sprite won't fit on this row, wrap to next
      if (cx + w > args.w) {
        cx = 0;
        cy += maxRowH;
        maxRowH = 0;
      }
      // record placement origin
      const originX = cx;
      const originY = cy;
      // advance cursor & track tallest sprite in this row
      cx += w;
      maxRowH = Math.max(maxRowH, h);

      // stamp pixels into object sprite
      c.forEach((v: number, i: number) => {
        if (v <= 0) return;
        const localX = i % w;
        const localY = Math.floor(i / w);
        const gx = originX + localX;
        const gy = originY + localY;
        // skip if out of vertical bounds
        if (gy < 0 || gy >= args.h) return;
        const idx = gy * args.w + gx;
        obj.sprite.c[idx] = v;
      });
    });
  };
  return {
    ...obj,
    step,
    setText: (newText: string) => {
      text = newText;
    }
  };
}
